import { observer } from 'mobx-react-lite';
import React from 'react';
import styles from '../program-sheet.module.scss';

import Skeleton from '@smart-tv/components/skeleton';
import Typography from '@smart-tv/components/typography';
import testIds from '@smart-tv/e2e/shared/variables';
import { IS_BROWSER } from '@smart-tv/utils/is-browser';

import { rootStore } from '../_stores/store-root';

export const SheetActionsMeta = observer(() => {
  const { sheet } = rootStore.sheetStore;

  if (!sheet) {
    return (
      <Typography className={styles['sheet-meta']}>
        <Skeleton width={200} />
      </Typography>
    );
  }

  if (!sheet.subtitle) return null;

  return (
    <Typography
      className={IS_BROWSER ? styles['sheet-meta__browser'] : styles['sheet-meta__tv']}
      variant="bodySmall"
      data-testid={testIds.programsheet.info.meta}
    >
      {sheet.subtitle}
    </Typography>
  );
});

export default SheetActionsMeta;
